import { useState } from "react"
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import apiParticipantes from "../api/Participantes/api-participantes";
import apiMaestras from "../api/Maestras/api-maestras";
import apiJurados from "../api/Jurados/api-jurados";
export const useListadoJurados = () => {

    const coloresEstado: any = {
        Pagado: "#00904C",
        Pendiente: "#4B4B4B"
    }


    const [filtros, setFiltros] = useState<any>({
        palabra_clave: "",
        linea_convocatoria: null,
        codigo: "",
        estado: null
    })

    const [cantidadPaginas, setCantidadPaginas] = useState(100);;
    const cambiarCantidadPaginas = (e: any, value: any) => {
        setCantidadPaginas(value);
    }
    const [categoriasLinea, setCategoriasLinea] = useState([]);
    const obtenerCategoriasConvoicatoria = async () => {
        try {
            const { data } = await apiConvocatorias.getAllCategoriasLineaConvocatoria();
            setCategoriasLinea(data);
        } catch (error) {

        }
    };
    const [lineaConvocatorias, setLineaConvocatorias] = useState([]);
    const obtenerLineaConvocatoria = async () => {
        try {
            const { data } = await apiConvocatorias.getLineaConvocatorias();
            setLineaConvocatorias(data);
            //console.log(data)
        } catch (error) {

        }
    };
    const [postulaciones, setPostulaciones] = useState([]);
    const [todasLasPostulaciones, setTodasLasPostulaciones] = useState([])
    const obtenerAllJuradosPago = async () => {
        try {
            const { data } = await apiJurados.getAllPostulacionesPagos();
            const datosFiltrados = data.map((x: any, idx: any) => {
                return {
                    ...x,
                    index: idx + 1
                }
            })
            //console.log(datosFiltrados)
            setPostulaciones(datosFiltrados);
            setTodasLasPostulaciones(datosFiltrados);
            //console.log('DATA PAGO::::');
            //console.log(data)
        } catch (error) {
            console.log(error)
        }
    };

    const handleLineaChange = async (id_linea: number) => {
      try {
        const { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
        console.log(data);
        setCategoriasLinea(data);
        setFiltros({
          ...filtros,
          linea_convocatoria: id_linea
        })
      } catch (error) {
        console.log(error)
      }
    };

    const getPostulacion = async (data) => {
      try {
        const postulacion = await apiParticipantes.consultarPostulacion(data);
        //console.log(postulacion.data);
        return postulacion.data;
      } catch (error) {
        console.error(error);
        throw error; // Puedes manejar el error aquí o lanzarlo nuevamente para manejarlo en obtenerProyectos
      }
    }

    const obtenerProyectosByLinea = async () => {
      try {
        let idLinea = filtros.linea_convocatoria
        let { data } = await apiParticipantes.obtenerResultadoEvaluacionByLinea(idLinea);
        data = data.filter((item) => item.estado === "Evaluado")
        //console.log(data)
        const proyectosFilter = await Promise.all(data.map(async (x, idx) => {
          const postulacion = await getPostulacion(x.id_postulacion);
          return {
            ...x,
            checked: false,
            postulacion,
            index: idx
          };
        }));

        setPostulaciones(proyectosFilter)
      } catch (error) {
        return console.error(error);
      }
    }

    const buscarFiltros = () => {

        if (filtros.linea_convocatoria !== '') {
          obtenerProyectosByLinea()
        }

    }

    const limpiarFiltros = () => {

        setPostulaciones(todasLasPostulaciones)

        setFiltros({
            palabra_clave: "",
            codigo: "",
            estado: null
        })
    }

    return {
        postulaciones,
        setPostulaciones,
        obtenerAllJuradosPago,
        cambiarCantidadPaginas,
        cantidadPaginas,
        coloresEstado,
        obtenerCategoriasConvoicatoria,
        obtenerLineaConvocatoria,
        categoriasLinea,
        lineaConvocatorias,
        filtros,
        setFiltros,
        limpiarFiltros,
        buscarFiltros,
        setTodasLasPostulaciones,
        handleLineaChange
    }
}